module.exports = __webpack_public_path__ + "img/spitter-attack-3.ab1e21e6.png";